import $ from "jquery";

// Workaround a font issue on Chrome/Windows.
import "lib/chrome_fonts";

// only do this once!
import "lib/polyfill";

// Polyfill for HTML5 placeholder
import "jquery-placeholder";

// Lazysizes provides lazy loading for responsive images.
import "lazysizes";

// these are dependencies of draggable/droppable
// probably not in the correct place, but it works
// well enough
import "jquery-ui/ui/core";
import "jquery-ui/ui/widget";
import "jquery-ui/ui/widgets/mouse";

// Adds touch support to jquery ui must be required after
// jquery-ui mouse
//
// We also need to inject a jQuery import, because touch-punch
// is unaware of javascript modules
//
// Obviously we want to aim to get rid of nonsense like this :)

// eslint-disable-next-line import/no-webpack-loader-syntax
import "imports-loader?jQuery=jquery!jquery-ui-touch-punch/jquery.ui.touch-punch";

import Backbone from "backbone";
import Rails from "rails-ujs";
import ForgeryProtection from "lib/ForgeryProtection";

import { eventBus, redirectTo } from "utils";

eventBus.subscribe((e) => {
  switch (e.type) {
    case "redirect":
      if (e.href) {
        redirectTo(e.href);
      } else {
        console.warn("The redirect event requires a href property");
      }
      break;

    default:
      // do nothing
  }
});

// Ensure CSRF-Token is included in all jQuery ajax requests
//
// It's important to note that this has a known race condition
// where AJAX requests which require the CSRF token will potentially
// be missing them if the initial request to get the CSRF token
// has not completed yet.
ForgeryProtection.CSRF.then(({ token }) => {
  $.ajaxPrefilter((options, originalOptions, xhr) => {
    if (!options.crossDomain) {
      xhr.setRequestHeader("X-CSRF-Token", token);
    }
  });
});

// Must call this to make rails-ujs work,
Rails.start();

// For some reason the Backbone initialisation doesn't correctly
// assign the global instance of jQuery to itself. Probably and order loading / scope
// issue which I can't figure out right at the moment.
Backbone.$ = $;

require("domready")(() => {
  // This applies the polyfill to each input with a placeholder
  $("input[placeholder]").placeholder();
});

// exposes active ajax connections via $.active on window, our specs
// occasionally use this to make sure ajax requests have completed
window.TC.activeAjax = () => $.active;

// because it's being called from the document we need to inject
// into global window scope
window.TC.TimeFormatter = require("lib/time_formatter").default;

// these are being called from inside ERB views, so it needs global scope for now
window.TC.BasePage = require("pages/base_page").default;
window.TC.ChooserView = require("views/chooser_view").default;
window.TC.ColumnPage = require("pages/column_page").default;
window.TC.ContentPage = require("pages/content_page").default;
window.TC.EditPasswordPage = require("pages/edit_password_page").default;
window.TC.EditProfilePage = require("pages/edit_profile_page").default;
window.TC.InfoPage = require("pages/info_page").default;
window.TC.InstitutionPage = require("pages/institution_page").default;
window.TC.NewEventPage = require("pages/new_event_page").default;
window.TC.NewRegistrationPage = require("pages/new_registration_page").default;
window.TC.NewsletterSubscriptionPage = require("pages/newsletter_subscription_page").default;
window.TC.NewsletterSubscriptionShowPage = require("pages/newsletter_subscription_show_page").default;
window.TC.PagePage = require("pages/page_page").default;
window.TC.PartnerPage = require("pages/partner_page").default;
window.TC.PodcastsPage = require("pages/podcasts_page").default;
window.TC.PodcastShowPage = require("pages/podcast_show_page").default;
window.TC.ProfileCredentialsPage = require("pages/profile_credentials_page").default;
window.TC.ProfileNewslettersPage = require("pages/profile_newsletters_page").default;
window.TC.ProfilePage = require("pages/profile_page").default;
window.TC.SearchPage = require("pages/search_page").default;
window.TC.TeamPage = require("pages/team_page").default;
window.TC.TopicPage = require("pages/topic_page").default;
window.TC.User = require("models/user").default;
